module.exports = __webpack_public_path__ + "static/media/pic-ht8.c976e284.jpg";